import { render } from "./SolicitudesIngreso.vue?vue&type=template&id=4d591f12&scoped=true"
import script from "./SolicitudesIngreso.vue?vue&type=script&lang=js"
export * from "./SolicitudesIngreso.vue?vue&type=script&lang=js"

import "./SolicitudesIngreso.vue?vue&type=style&index=0&id=4d591f12&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d591f12"]])

export default __exports__